import { List } from 'immutable';
import { Component, ReactNode } from 'react';
import { Ability } from 'app/constants/enums/Ability';
import { isRestricted } from 'app/utils/auth';

type RenderPropType = (isRestricted: boolean) => ReactNode;

interface IProps {
  alphaOnly?: boolean;
  allow?: List<Ability> | Ability[];
  children: ReactNode | RenderPropType;
  isAuthenticated: boolean;
  userAbilities?: List<Ability> | Ability[];
}

export default class RestrictContent extends Component<IProps> {
  public render() {
    const { alphaOnly, allow, children, isAuthenticated, userAbilities } = this.props;
    const contentRestricted = isRestricted(allow, isAuthenticated, userAbilities, alphaOnly);

    if (children instanceof Function) {
      return children(contentRestricted);
    } else {
      if (contentRestricted) {
        return null;
      } else {
        return children;
      }
    }
  }
}
